import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['urlInput', 'indicator']
  static values = { debounceMs: { type: Number, default: 300 } }

  static youtubePatterns = [
    /^https?:\/\/(www\.)?youtube\.com\/watch\?v=/i,
    /^https?:\/\/(www\.)?youtube\.com\/live\//i,
    /^https?:\/\/(www\.)?youtube\.com\/shorts\//i,
    /^https?:\/\/(www\.)?youtu\.be\//i,
    /^https?:\/\/(www\.)?youtube\.com\/embed\//i
  ]

  connect() {
    this.debounceTimer = null
    this.lastDetectedState = null
    if (this.hasUrlInputTarget && this.urlInputTarget.value) {
      this.detectImmediate()
    }
  }

  disconnect() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer)
  }

  detect() {
    if (this.debounceTimer) clearTimeout(this.debounceTimer)
    this.debounceTimer = setTimeout(() => this.detectImmediate(), this.debounceMsValue)
  }

  detectImmediate() {
    const url = this.urlInputTarget?.value?.trim() || ''
    const isYoutube = this.isYoutubeUrl(url)
    if (isYoutube !== this.lastDetectedState) {
      this.lastDetectedState = isYoutube
      this.emitEvent(isYoutube, url)
      this.updateIndicator(isYoutube)
    }
  }

  isYoutubeUrl(url) {
    if (!url) return false
    return this.constructor.youtubePatterns.some(pattern => pattern.test(url))
  }

  emitEvent(isYoutube, url) {
    const event = new CustomEvent('youtube-detected', {
      bubbles: true,
      detail: { isYoutube, url }
    })
    window.dispatchEvent(event)
  }

  updateIndicator(isYoutube) {
    if (!this.hasIndicatorTarget) return
    this.indicatorTarget.hidden = !isYoutube
    this.indicatorTarget.textContent = isYoutube ? 'YouTube detectado' : ''
  }
}
